import { isAndroid, isIOS, isMobile } from "react-device-detect";

import "./App.scss";
import images from "./assets/images";
import ChildSafety from "./ChildSafety";

import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Mousewheel, Navigation, Pagination } from "swiper";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

SwiperCore.use([Navigation, Pagination]);

const SCREENSHOT_LIST = [
  images.web_01,
  images.web_02,
  images.web_03,
  images.web_08,
  images.web_04,
  images.web_05,
  images.web_06,
  images.web_07,
];

const App = () => {
  const pathname = typeof window !== "undefined" ? window.location.pathname : "";
  if (pathname === "/child-safety" || pathname === "/child-safety/") {
    return <ChildSafety />;
  }

  const onClickIcon = () => {
    if (isMobile) {
      isAndroid ? onClickPlaystore() : onClickAppstore();
    }
  };

  const onClickPlaystore = () => {
    const url =
      isMobile && isAndroid
        ? "market://details?id=com.giftsets.queentalk"
        : "http://play.google.com/store/apps/details?id=com.giftsets.queentalk";
    const target = isMobile ? undefined : "_blank";
    window.open(url, target);
  };

  const onClickAppstore = () => {
    const url =
      isMobile && isIOS
        ? "itms-apps://itunes.apple.com/app/id1567940653"
        : "https://apps.apple.com/us/app/%ED%80%B8%ED%86%A1-%EC%9D%B5%EB%AA%85-%EB%9E%9C%EB%8D%A4%EC%B1%84%ED%8C%85-%EC%B9%9C%EA%B5%AC%EC%82%AC%EA%B7%80%EA%B8%B0/id1556187909";
    const target = isMobile ? undefined : "_blank";
    window.open(url, target);
  };

  const onClickInstagram = () => {
    const url = "https://instagram.com/_queen.talk_";
    window.open(url);
  };

  const renderSwiperSlide = (item, index) => {
    return (
      <SwiperSlide>
        <img src={item} alt="Screenshot" />
      </SwiperSlide>
    );
  };

  return (
    <div className="App">
      <img
        src={images.ic_app}
        className="App-icon"
        alt="Icon"
        onClick={onClickIcon}
      />
      <p className="App-name-text">{"QueenTalk"}</p>

      <Swiper
        direction={"horizontal"}
        slidesPerView={1}
        spaceBetween={0}
        mousewheel={true}
        pagination={{
          clickable: true,
        }}
        modules={[Pagination]}
        scrollbar={{ draggable: true }}
        breakpoints={{
          720: {
            slidesPerView: 2,
          },
          1080: {
            slidesPerView: 3,
          },
          1440: {
            slidesPerView: 4,
          },
          1800: {
            slidesPerView: 5,
          },
          2160: {
            slidesPerView: 6,
          },
        }}
      >
        {SCREENSHOT_LIST.map((item, index) => {
          return renderSwiperSlide(item, index);
        })}
      </Swiper>

      <div className="App-download-container">
        <img
          src={images.download_playstore}
          className="App-download"
          alt="Download"
          onClick={onClickPlaystore}
        />
        {/* <div className="Divider" />
        <img
          src={images.download_appstore}
          className="App-download"
          alt="Download"
          onClick={onClickAppstore}
        /> */}
      </div>

      <div className="App-link-container" onClick={onClickInstagram}>
        <img
          src={images.ic_instagram}
          className="App-link-icon"
          alt="Instagram"
        />
        <p className="App-link-text">{"_Queen.Talk_"}</p>
      </div>
    </div>
  );
};

export default App;
